"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CardDetails {
}
exports.default = CardDetails;
//# sourceMappingURL=CardDetails.js.map